export * from '../src/composites/wui-wallet-image/index.js';
//# sourceMappingURL=wui-wallet-image.js.map